import React, { useState, useEffect, useRef } from "react";
import { HorizontalBar, Pie } from "react-chartjs-2";
import { formatMoneda } from "../../util/varios";
import moment from "moment";
import axios from "axios";
import { Mensaje } from "../../components/mensajes";
import useTable from "../../components/useTable";
import { TableBody, TableRow, TableCell } from "@material-ui/core";
import { Loader, Dimmer } from "semantic-ui-react";
import RegistrarPagoNotadeEntrega from "./registrarPagoNotaEntrega";
import RegistrarPagodeFactura from "./registrarPagoFactura";
import RegistrarPagoNotadeDebito from "./registrarPagoNotaDebito";

function GestionCuentasCobrar() {
  const token = sessionStorage.getItem("jwtToken");
  const op = require("../../../public/modulos/datos");
  const ncaja = JSON.parse(sessionStorage.getItem("numcaja"));
  const fechaSistema = JSON.parse(sessionStorage.getItem("fechasistema"));
  const accbtncntxcobrar = JSON.parse(
    sessionStorage.getItem("accbtncntxcobrarc")
  );

  const headCells = [
    {
      id: "9",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: <i className="far fa-eye"></i>,
      textAlign: "center",
    },
    {
      id: "1",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "FACTURA N°",
      textAlign: "center",
    },
    {
      id: "2",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "FECHA EMISION",
      textAlign: "center",
    },
    {
      id: "0",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "FECHA VENCIMIENTO",
      textAlign: "center",
    },
    {
      id: "3",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "DIAS (CREDITO)",
      textAlign: "center",
    },
    {
      id: "4",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "DIAS (TRANSCURRIDO)",
      textAlign: "center",
    },
    {
      id: "5",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "CLIENTE",
      textAlign: "center",
    },
    {
      id: "6",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "MONTO",
      textAlign: "center",
    },
    {
      id: "7",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "ABONO",
      textAlign: "center",
    },
    {
      id: "8",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "SALDO",
      textAlign: "center",
    },
    {
      id: "4",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "STATUS",
      textAlign: "center",
    },
  ];

  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });

  const [colorF, setColorF] = useState([]);
  const [datos, setDatos] = useState([
    {
      color: "#ffc107",
      nombre: "Total Por Vencer",
      valor: "0,00",
    },
    {
      color: "#dc3545",
      nombre: "Total Vencido",
      valor: "0,00",
    },
  ]);
  const txtBuscar = useRef();
  const [records, setRecords] = useState([]);
  const [activate, setActivate] = useState(false);
  const [mostrar1, setMostrar1] = useState(false);
  const [mostrar2, setMostrar2] = useState(false);
  const [mostrar3, setMostrar3] = useState(false);
  const [data, setData] = useState();
  const [idnot, setIdnot] = useState(0);
  const [abono, setAbono] = useState(0.0);
  const [anticipo, setAnticipo] = useState(0.0);
  const [idfact, setIdfact] = useState(0);
  const [options, setOptions] = useState();
  const [totalVentas, setTotalVentas] = useState(0.0);
  const [totalCobrado, setTotalCobrado] = useState(0.0);
  const [totalPorCobrar, setTotalPorCobrar] = useState(0.0);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;

    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            if (
              moment(x.fecha)
                .format("DD-MM-YYYY")
                .toLowerCase()
                .includes(target.value.toLowerCase()) ||
              moment(x.fechavencimientof)
                .format("DD-MM-YYYY")
                .toLowerCase()
                .includes(target.value.toLowerCase()) ||
              x.cliente.toLowerCase().includes(target.value.toLowerCase()) ||
              x.numfactura.toLowerCase().includes(target.value.toLowerCase()) ||
              formatMoneda(
                x.totalmonto.toString().replace(",", "").replace(".", ","),
                ",",
                ".",
                2
              )
                .toLowerCase()
                .includes(target.value.toLowerCase()) ||
              x.statuscredito.toLowerCase().includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
        }
      },
    });
  };

  const seleccionarFacturas = () => {
    let endpoint = `${op.conexion}/api/registropago/seleccionarfacturas?&status=0&anio=todos&mes=''`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            txtBuscar.current.focus();
            setRecords(response.data);
            let vnt = 0.0;
            let cbd = 0.0;
            let pcb = 0.0;

            let tt = 0.0;
            let abo = 0.0;
            let rt = 0.0;

            for (let i = 0; i < response.data.length; i++) {
              tt = tt + parseFloat(response.data[i].totalmonto);
              abo = abo + parseFloat(response.data[i].abono);
            }

            rt = tt - abo;

            for (let i = 0; i < response.data.length; i++) {
              if (response.data[i].status === 0) {
                vnt = vnt + parseFloat(response.data[i].totalmonto);

                if (response.data[i].statuscredito === "vencido") {
                  cbd = cbd + parseFloat(response.data[i].totalmonto);
                }

                if (response.data[i].statuscredito === "por vencer") {
                  pcb = pcb + parseFloat(response.data[i].totalmonto);
                }
              }
            }

            setTotalVentas(vnt);
            setTotalCobrado(cbd);
            setTotalPorCobrar(pcb);
            setDatos([
              {
                color: "#ffc107",
                nombre: "Total Por Vencer",
                valor: formatMoneda(
                  pcb.toString().replace(",", "").replace(".", ","),
                  ",",
                  ".",
                  2
                ),
              },
              {
                color: "#dc3545",
                nombre: "Total Vencido",
                valor: formatMoneda(
                  cbd.toString().replace(",", "").replace(".", ","),
                  ",",
                  ".",
                  2
                ),
              },
            ]);
          } else {
            setRecords([]);
            setTotalVentas(0.0);
            setTotalCobrado(0.0);
            setTotalPorCobrar(0.0);
            setDatos([
              {
                color: "#ffc107",
                nombre: "Total Por Vencer",
                valor: "0,00",
              },
              {
                color: "#dc3545",
                nombre: "Total Vencido",
                valor: "0,00",
              },
            ]);
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => {
        setActivate(false);
      });
  };

  const onGestionar = (item) => (e) => {
    if (ncaja !== "") {
      if (
        accbtncntxcobrar &&
        accbtncntxcobrar.toString().substring(0, 1) === "1"
      ) {
        if (item.numfactura.toString().substring(0, 2) === "NE") {
          setIdnot(item.idfactura);
          setAbono(item.abono);
          setAnticipo(item.anticipo);
          setMostrar1(true);
        } else if (item.numfactura.toString().substring(0, 2) === "F0") {
          setIdfact(item.idfactura);
          setAbono(item.abono);
          setAnticipo(item.anticipo);
          setMostrar2(true);
        } else if (item.numfactura.toString().substring(0, 2) === "ND") {
          setAbono(item.abono);
          setAnticipo(item.anticipo);
          setIdnot(item.idfactura);
          setMostrar3(true);
        }
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación.",
          texto: "¡No Posee Permiso para Realizar esta Acción!",
          icono: "error",
        });
      }
    } else {
      setMensaje({
        mostrar: true,
        titulo: "Notificación.",
        texto: "¡No Posee un Número de Caja Asignada!",
        icono: "error",
      });
    }
  };

  const dataTorta = {
    labels: ["Por Vencer", "Vencido"],
    leyend: true,
    datasets: [
      {
        label: "#",
        data: [totalPorCobrar.toFixed(2), totalCobrado.toFixed(2)],
        backgroundColor: ["#ffc107", "#dc3545"],
        borderColor: ["#ffc107", "#dc3545"],
        borderWidth: 1,
        hoverBorderWidth: 15,
      },
    ],
  };

  const optionsTorta = {
    responsive: false,
    legend: {
      position: "top",
      display: true,
    },
    title: {
      display: true,
      text: `Monto Total por Cobrar: ${formatMoneda(
        totalVentas.toString().replace(",", "").replace(".", ","),
        ",",
        ".",
        2
      )}`,
    },
  };

  useEffect(() => {
    const listaclientes = [];
    const totales = [];

    for (let i = 0; i < records.length; i++) {
      if (!listaclientes.includes(records[i].cliente)) {
        listaclientes.push(records[i].cliente);
        colorF.push("#dc3545");
      }
    }

    for (let x = 0; x < listaclientes.length; x++) {
      let monto = 0.0;
      for (let i = 0; i < records.length; i++) {
        if (listaclientes[x] === records[i].cliente) {
          monto = monto + parseFloat(records[i].totalmonto);
        }
      }
      totales.push(monto.toString());
    }

    setData({
      labels: listaclientes,
      datasets: [
        {
          label: "Monto por Cobrar",
          data: totales,
          borderColor: colorF,
          backgroundColor: colorF,
        },
      ],
    });
    setOptions({
      indexAxis: "y",
      elements: {
        bar: {
          borderWidth: 2,
        },
      },
      responsive: true,
      plugins: {
        legend: {
          position: "right",
        },
        title: {
          display: true,
          text: "Chart.js Horizontal Bar Chart",
        },
      },
    });
  }, [records]);

  useEffect(() => {
    seleccionarFacturas();
  }, []);

  return (
    <div className="col-md-12 mx-auto">
      <div className="col-md-12 mt-2">
        <div>
          <Mensaje
            mensaje={mensaje}
            onHide={() =>
              setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
            }
          />
          <div className="container-fluid px-3 py-2">
            <div className="row col-md-12 card py-3 mx-auto">
              <div className="row col-md-12 mx-auto">
                <div className="col-md-6 mx-auto h-100 row">
                  <div className="col-md-12 card row h-100">
                    <div className="col-lg-12 row mx-auto">
                      <div
                        className="row col-lg-6 col-md-12 h-50 mx-auto justify-content-center"
                        style={{ display: "grid" }}
                      >
                        <div className="col-md-12">
                          <Pie
                            options={optionsTorta}
                            height={300}
                            width={300}
                            data={dataTorta}
                          />
                        </div>
                        <div className="col-md-12" style={{ padding: "10vh" }}>
                          <table className="table tablet-responsive table-striped">
                            <tbody>
                              {datos &&
                                datos.map((item, index) => (
                                  <tr key={index}>
                                    <td
                                      style={{
                                        backgroundColor: item.color,
                                        border: "#000000 1px solid",
                                        width: "20px",
                                        fontSize: "10px",
                                        margin: 0,
                                        padding: 0,
                                      }}
                                    ></td>
                                    <td
                                      style={{
                                        border: "#000000 1px solid",
                                        fontSize: "10px",
                                        margin: 0,
                                        padding: 0,
                                        paddingLeft: "3px",
                                      }}
                                    >
                                      {item.nombre}
                                    </td>
                                    <td
                                      style={{
                                        border: "#000000 1px solid",
                                        textAlign: "end",
                                        fontSize: "10px",
                                        margin: 0,
                                        padding: 0,
                                        paddingRight: "3px",
                                      }}
                                    >
                                      {item.valor}
                                    </td>
                                  </tr>
                                ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <div className=" col-lg-6 col-md-12 my-auto bg-light border-azul row h-100 justify-content-center rounded mx-auto px-0">
                        <div className="col-md-12 h-100 mb-2">
                          <div className="col-md-12 bg-primary mt-2 py-5 mx-auto rounded shadow d-flex align-items-center">
                            <div className="col-md-12 justify-content-center">
                              <div className="col-md-12 d-flex justify-center mx-auto">
                                <label className=" text-center fw-bold text-light mx-auto ">
                                  Datos Estadisticos
                                </label>
                              </div>
                              {/*                               <select
                                className="form-select form-select-sm rounded mx-auto col-md-6 text-center text-light fw-bold text-uppercase"
                                name="mesEst"
                                defaultValue=""
                                ref={cmbMesEst}
                                aria-label=".form-select-sm example"
                                onChange={onChange}
                              >
                                <option value={"anual"}> - Anual - </option>
                                <option value={"01"}> - Enero - </option>
                                <option value={"02"}> - Febrero - </option>
                                <option value={"03"}> - Marzo - </option>
                                <option value={"04"}> - Abril - </option>
                                <option value={"05"}> - Mayo - </option>
                                <option value={"06"}> - Junio - </option>
                                <option value={"07"}> - Julio - </option>
                                <option value={"08"}> - Agosto - </option>
                                <option value={"09"}> - Septiembre - </option>
                                <option value={"10"}> - Octubre - </option>
                                <option value={"11"}> - Noviembre - </option>
                                <option value={"12"}> - Diciembre - </option>
                              </select> */}
                            </div>
                          </div>
                          <button
                            className=" btn col-md-12 bg-success mt-2 py-3 mx-auto rounded shadow d-flex align-items-center"
                            // onClick={blanquear}
                          >
                            <div className="input-group input-group-sm justify-content-between">
                              <span
                                className="input-group-text border-0 bg-transparent fw-bold text-light"
                                id="inputGroup-sizing-sm"
                              >
                                Total Fact. a Credito:
                              </span>
                              <input
                                type="text"
                                className="form-control col-md-6 rounded bg-transparent border-0 fw-bold text-right text-light"
                                value={formatMoneda(
                                  totalVentas
                                    .toString()
                                    .replace(",", "")
                                    .replace(".", ","),
                                  ",",
                                  ".",
                                  2
                                )}
                                disabled
                                aria-label="Sizing example input"
                                aria-describedby="inputGroup-sizing-sm"
                              />
                            </div>
                          </button>
                          <button
                            className=" btn col-md-12 bg-warning mt-2 py-3 mx-auto rounded shadow d-flex align-items-center"
                            // onClick={onClickButtons(" ")}
                          >
                            <div className="input-group input-group-sm justify-content-between">
                              <span
                                className="input-group-text border-0 bg-transparent fw-bold"
                                id="inputGroup-sizing-sm"
                              >
                                Total de Fact. por Vencer :
                              </span>
                              <input
                                type="text"
                                className="form-control col-md-6 rounded bg-transparent border-0 fw-bold text-right"
                                value={formatMoneda(
                                  totalPorCobrar
                                    .toString()
                                    .replace(",", "")
                                    .replace(".", ","),
                                  ",",
                                  ".",
                                  2
                                )}
                                disabled
                                aria-label="Sizing example input"
                                aria-describedby="inputGroup-sizing-sm"
                              />
                            </div>
                          </button>
                          <button
                            className=" btn col-md-12 bg-danger mt-2 py-3 mx-auto rounded shadow d-flex align-items-center"
                            // onClick={onClickButtons("vencido")}
                          >
                            <div className="input-group input-group-sm justify-content-between">
                              <span
                                className="input-group-text border-0 bg-transparent fw-bold text-light"
                                id="inputGroup-sizing-sm"
                              >
                                Total de Fact. Vencidas:
                              </span>
                              <input
                                type="text"
                                className="form-control col-md-6 rounded bg-transparent border-0 fw-bold text-right text-light"
                                value={formatMoneda(
                                  totalCobrado
                                    .toString()
                                    .replace(",", "")
                                    .replace(".", ","),
                                  ",",
                                  ".",
                                  2
                                )}
                                disabled
                                aria-label="Sizing example input"
                                aria-describedby="inputGroup-sizing-sm"
                              />
                            </div>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 py-2 row mx-auto">
                  <div className="col-md-12 h-100 my-auto">
                    {/*                     <div className="col-md-12 row mx-auto">
                      <div
                        className="input-group input-group-sm mb-2 col-pd-150"
                        style={{ fontSizeAdjust: "0.6" }}
                      >
                        <span
                          className="input-group-text"
                          id="inputGroup-sizing-sm"
                        >
                          AÑO:
                        </span>
                        <select
                          onChange={onChange}
                          ref={cmdAnual}
                          name="cmdanual"
                          className="form-select form-select-sm fw-bold"
                          aria-label=".form-select-sm example"
                        >
                          <option value={anioActu}>{anioActu}</option>
                          <option value={anioActu - 1}>{anioActu - 1}</option>
                          <option value={anioActu - 2}>{anioActu - 2}</option>
                        </select>
                      </div>
                    </div> */}
                    <div className="row mt-3 py-0 my-0 m-0">
                      <h5
                        className="m-0 titulo-content"
                        style={{ fontSize: 20 }}
                      >
                        Listado de Clientes
                      </h5>
                      <hr className="w-50 my-0" />
                      <HorizontalBar options={options} data={data} />
                    </div>
                  </div>
                </div>
                <div className="col-md-12 row h-100">
                  <div className="row col-md-12 mt-3">
                    <div className="input-group col-md-3 input-group-sm">
                      <input
                        type="text"
                        onChange={handleSearch}
                        placeholder="Buscar"
                        title="Buscar Factura"
                        className="form-control text-uppercase"
                        ref={txtBuscar}
                      />
                      <button
                        className="btn"
                        style={{
                          pointerEvents: "none",
                          backgroundColor: "rgba(5, 81, 130, 1)",
                          color: "#FFFFFF",
                        }}
                      >
                        <i className="fa fa-search"></i>
                      </button>
                    </div>
                  </div>
                  <div className="col-md-12 row mx-auto py-3 justify-content-end">
                    <div className="col-md-12 h-50 mt-2 px-0 mx-0 rounded">
                      <TblContainer
                        container={{
                          height: 220,
                          width: "100%",
                          overflow: "auto",
                          padding: "2px",
                          fontSizeAdjust: "0.6",
                        }}
                      >
                        <TblHead />
                        <TableBody className="overflow-hidden table-bordered">
                          {records &&
                            recordsAfterPagingAndSorting().map(
                              (item, index) => (
                                <TableRow
                                  key={index}
                                  style={{
                                    padding: "0",
                                    fontSizeAdjust: "0.6",
                                  }}
                                >
                                  <TableCell
                                    className="align-baseline bg-light"
                                    style={{
                                      textAlign: "center",
                                      width: "40px",
                                    }}
                                  >
                                    <button
                                      className="btn btn-sm btn-primary rounded-circle"
                                      title="Gestionar Documento"
                                      onClick={onGestionar(item)}
                                    >
                                      <i className="fas fa-redo-alt"></i>
                                    </button>
                                  </TableCell>
                                  <TableCell
                                    className="align-baseBar bg-light"
                                    style={{
                                      textAlign: "center",
                                      width: "80px",
                                    }}
                                  >
                                    {item.numfactura}
                                  </TableCell>
                                  <TableCell
                                    className="align-baseline bg-light"
                                    style={{
                                      textAlign: "center",
                                      width: "80px",
                                    }}
                                  >
                                    {moment(item.fecha).format("DD-MM-YYYY")}
                                  </TableCell>
                                  <TableCell
                                    className="align-baseline bg-light"
                                    style={{
                                      textAlign: "center",
                                      width: "80px",
                                    }}
                                  >
                                    {item.creditof &&
                                      moment(item.fechavencimientof).format(
                                        "DD-MM-YYYY"
                                      )}
                                  </TableCell>
                                  <TableCell
                                    className="align-baseline bg-light"
                                    style={{
                                      textAlign: "center",
                                      width: "50px",
                                    }}
                                  >
                                    {item.creditof &&
                                      moment(item.fechavencimientof).diff(
                                        moment(item.fecha),
                                        "days"
                                      )}
                                  </TableCell>
                                  <TableCell
                                    className="align-baseline bg-light"
                                    style={{
                                      textAlign: "center",
                                      width: "50px",
                                    }}
                                  >
                                    {moment(fechaSistema).diff(
                                      moment(item.fecha),
                                      "days"
                                    ) > item.diasC ? (
                                      <span className="fw-bold">
                                        {moment(fechaSistema).diff(
                                          moment(item.fecha),
                                          "days"
                                        )}{" "}
                                      </span>
                                    ) : (
                                      <span className="fw-bold">
                                        {moment(fechaSistema).diff(
                                          moment(item.fecha),
                                          "days"
                                        )}{" "}
                                      </span>
                                    )}
                                  </TableCell>
                                  <TableCell
                                    className="align-baseline bg-light"
                                    style={{
                                      textAlign: "left",
                                      width: "350px",
                                    }}
                                  >
                                    {item.cliente}
                                  </TableCell>
                                  <TableCell
                                    className="align-baseline bg-light"
                                    style={{
                                      textAlign: "right",
                                      width: "100px",
                                    }}
                                  >
                                    {formatMoneda(
                                      item.totalmonto
                                        .toString()
                                        .replace(",", "")
                                        .replace(".", ","),
                                      ",",
                                      ".",
                                      2
                                    )}
                                  </TableCell>
                                  <TableCell
                                    className="align-baseline bg-light"
                                    style={{
                                      textAlign: "right",
                                      width: "100px",
                                    }}
                                  >
                                    {formatMoneda(
                                      item.abono
                                        .toString()
                                        .replace(",", "")
                                        .replace(".", ","),
                                      ",",
                                      ".",
                                      2
                                    )}
                                  </TableCell>
                                  <TableCell
                                    className="align-baseline bg-light"
                                    style={{
                                      textAlign: "right",
                                      width: "100px",
                                    }}
                                  >
                                    {formatMoneda(
                                      (item.totalmonto - item.abono)
                                        .toString()
                                        .replace(",", "")
                                        .replace(".", ","),
                                      ",",
                                      ".",
                                      2
                                    )}
                                  </TableCell>
                                  <TableCell
                                    className="align-baseline bg-light"
                                    style={{
                                      textAlign: "center",
                                      width: "80px",
                                    }}
                                  >
                                    <span
                                      className="fw-bold"
                                      style={{
                                        color:
                                          item.statuscredito === "por vencer"
                                            ? "green"
                                            : "red",
                                      }}
                                    >
                                      {item.creditof
                                        ? item.statuscredito
                                        : "Por Pagar"}
                                    </span>
                                  </TableCell>
                                </TableRow>
                              )
                            )}
                        </TableBody>
                      </TblContainer>
                      <TblPagination />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <RegistrarPagoNotadeEntrega
        show={mostrar1}
        idnot={idnot}
        abono={abono}
        anticipo={anticipo}
        ope={1}
        onRenderizar={seleccionarFacturas}
        onHideCancelar={() => {
          setMostrar1(false);
        }}
      />
      <RegistrarPagodeFactura
        show={mostrar2}
        idfactu={idfact}
        abono={abono}
        anticipo={anticipo}
        ope={1}
        onRenderizar={seleccionarFacturas}
        onHideCancelar={() => {
          setMostrar2(false);
        }}
      />
      <RegistrarPagoNotadeDebito
        show={mostrar3}
        idnot={idnot}
        abono={abono}
        anticipo={anticipo}
        ope={1}
        onRenderizar={seleccionarFacturas}
        onHideCancelar={() => {
          setMostrar3(false);
        }}
      />
      <Dimmer active={activate} inverted>
        <Loader inverted>cargando...</Loader>
      </Dimmer>
    </div>
  );
}

export default GestionCuentasCobrar;



// WEBPACK FOOTER //
// ./src/components/finanzas/gestionCuentasCobrar.js